import { render } from "./CookiesFunctionalTable.vue?vue&type=template&id=29ba70d3&scoped=true&ts=true"
import script from "./CookiesFunctionalTable.vue?vue&type=script&lang=ts"
export * from "./CookiesFunctionalTable.vue?vue&type=script&lang=ts"

import "./CookiesFunctionalTable.vue?vue&type=style&index=0&id=29ba70d3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ba70d3"]])

export default __exports__